import React from "react";
import { Badge, Form } from "react-bootstrap";
import { format } from "date-fns";
const OrgDetails = ({ orgsData }) => {
  return (
    <>
      {/*  */}
      <div className="tab-pane active" id="personalDetails" role="tabpanel">
        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-header bg-dark text-white py-3">
            <h5
              className="card-title mb-0 fs-4 fw-bold"
              data-testid="Organizations-Info"
            >
              Organizations Info
            </h5>
          </div>

          <div className="card-body bg-dark text-white">
            <div className="row g-4">
              {[
                {
                  label: "Organizations Name",
                  value: orgsData?.name || "",
                },
                {
                  label: "Email",
                  value: orgsData?.email || "",
                },
              ].map((item, index) => (
                <div className="col-lg-6" key={index}>
                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                    <span className="text-secondary fs-6 fw-semibold">
                      {item.label}
                    </span>
                    <span className="d-block fs-5 fw-medium">{item.value}</span>
                  </div>
                </div>
              ))}
              <div className="col-lg-6">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">Phone</span>
                  <span className="d-block fs-5 fw-medium">
                    {orgsData?.phone || ""}
                  </span>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">
                    Website
                  </span>
                  <a
                    href="https://www.playitforward.fun/"
                    target="blank"
                    className="d-block text-primary fs-5 text-decoration-none fw-medium"
                  >
                    {orgsData?.website || ""}
                  </a>
                </div>
              </div>
              {[
                {
                  label: "Address",
                  value: orgsData?.address || "",
                },
              ].map((item, index) => (
                <>
                  <div className="col-lg-6" key={index}>
                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                      <span className="text-secondary fs-6 fw-semibold">
                        {item.label}
                      </span>
                      <span className="d-block fs-5 fw-medium text-light">
                        {item.value}
                      </span>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="p-3 bg-secondary bg-opacity-10 rounded">
                      <span className="text-secondary fs-6 fw-semibold">
                        Founded
                      </span>
                      <span className="d-block fs-5 fw-medium text-true">
                        {orgsData?.founded || ""}
                      </span>
                    </div>
                  </div>
                </>
              ))}

              <div className="col-lg-12">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">
                    Focused Areas
                  </span>
                  <div>
                    {orgsData?.focusAreas?.map((m) => (
                      <Badge bg="secondary" className="mr-2 p-2">
                        <p className="fs-6 mb-0">{m}</p>
                      </Badge>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                  <span className="text-secondary fs-6 fw-semibold">
                    Mission
                  </span>
                  <p className="fs-5 mb-0">{orgsData?.mission || ""}</p>
                </div>
              </div>
              {[
                {
                  item: "Status",
                  value: orgsData?.status ? "Active" : "In-Active",
                },
                {
                  item: "Created At",
                  value: orgsData?.createdAt
                    ? format(orgsData.createdAt, "PP")
                    : "",
                },
                {
                  item: "Updated At",
                  value: orgsData?.updatedAt
                    ? format(orgsData.updatedAt, "PP")
                    : "",
                },
                {
                  item: "Deleted At",
                  value: orgsData?.deletedAt
                    ? format(orgsData.deletedAt, "PP")
                    : "",
                },
                {
                  item: "Created By",
                  value: `${orgsData?.org_added_by?.first_name || ""} ${orgsData?.org_added_by?.last_name || ""}`,
                },
                {
                  item: "Updated By",
                  value: `${orgsData?.org_updated_by?.first_name || ""} ${orgsData?.org_updated_by?.last_name || ""}`,
                },
              ].map((rec) => (
                <div className="col-lg-6" key={rec.item}>
                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                    <span className="text-secondary fs-6 fw-semibold">
                      {rec.item}
                    </span>
                    <span
                      className={`d-block fs-5 fw-medium ${!rec?.value?.trim() && "text-danger"}`}
                    >
                      {rec?.value?.trim() || "N/A"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrgDetails;
